// Import model
import { CreateBomKitItemRequest } from '../models/CreateBomKitItemRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CreateBomKitItemRequest - handles JSON serialization and deserialization with type validation
 */
export class CreateBomKitItemRequestSerializer {
  /**
   * Deserializes a JSON string into a CreateBomKitItemRequest instance
   */
  static deserialize(json: string): CreateBomKitItemRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CreateBomKitItemRequest instance
   */
  static fromObject(obj: any): CreateBomKitItemRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CreateBomKitItemRequest');
    }


    const instance: CreateBomKitItemRequest = {
      createdBy: obj['createdBy'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      tags: obj['tags'] ? (obj['tags'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      itemId: obj['itemId'] as string,
      bomKitId: obj['bomKitId'] as string,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CreateBomKitItemRequest instances
   */
  static deserializeArray(json: string): CreateBomKitItemRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CreateBomKitItemRequest instance to a JSON string
   */
  static serialize(instance: CreateBomKitItemRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CreateBomKitItemRequest instance to a plain object
   */
  static toObject(instance: CreateBomKitItemRequest): any {
    return {
      'createdBy': instance.createdBy,
      'isActive': instance.isActive,
      'tags': instance.tags?.map((item: any) =>
        item
      ),
      'name': instance.name,
      'description': instance.description,
      'itemId': instance.itemId,
      'bomKitId': instance.bomKitId,
    };
  }

  /**
   * Serializes an array of CreateBomKitItemRequest instances to a JSON string
   */
  static serializeArray(instances: CreateBomKitItemRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
